/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import {
  PosteResidenceTime,
  BoonLister,
  ResidenceTime,
  SpeedSelfcleaning,
  Title,
} from '../H2SParam/helper';
import { formScoringGridType } from '../H2SParam/Interface';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import SaveButton from '../../components/common/SaveButton';
import { H2sApi } from '../../utils/api';
import { Toast } from 'primereact/toast';
import { loaderDataComponent } from '../../utils/helper';

declare type ScoringGridProps = {
  contractId: string;
};

function ScoringGridParameter({ contractId }: ScoringGridProps) {
  const toast = useRef<any>(null);
  const [dataList, setDataList] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const [form, setForm] = useState<formScoringGridType>({
    id: dataList?.id,
    mainInstallCode: dataList?.mainInstallCode,
    posteResidenceTime1: dataList?.posteResidenceTime1,
    posteResidenceTime2: dataList?.posteResidenceTime2,
    posteResidenceTime3: dataList?.posteResidenceTime3,
    residenceTime1: dataList?.residenceTime1,
    residenceTime2: dataList?.residenceTime2,
    residenceTime3: dataList?.residenceTime3,
    selfCleansing1: dataList?.selfCleansing1,
    selfCleansing2: dataList?.selfCleansing2,
    selfCleansing3: dataList?.selfCleansing3,
    boonLister1: dataList?.boonLister1,
    boonLister2: dataList?.boonLister2,
    boonLister3: dataList?.boonLister3,
  });
  const [showErrorMessage, setShowErrorMessage] = React.useState<any>({
    bach: false,
    notationGrill: false,
  });

  // Show toast function
  const ShowToast = (severity: any, summary: any, detail: any) => {
    return toast.current?.show({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  };

  const getH2sParam = async () => {
    setLoading(true);
    try {
      const response = await H2sApi.getH2sContractParameters(contractId);
      setDataList(response.data);
      if (response.status === 200 && response.data.length < 1) {
        ShowToast(
          'error',
          'Erreur',
          'Nous ne pouvons pas afficher la donnée car elle est inexistante',
        );
      }
    } catch (e) {
      ShowToast(
        'error',
        'Erreur',
        'Erreur lors de la récuperation des données de paramètres',
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    getH2sParam();
  }, []);

  useEffect(() => {
    setForm(dataList);
  }, [dataList]);

  useEffect(() => {
    if(form?.residenceTime1! > form?.residenceTime2!
      || form?.residenceTime2! > form?.residenceTime3!
      || form?.selfCleansing1! < form?.selfCleansing2!
      || form?.selfCleansing2! < form?.selfCleansing3!
      || form?.boonLister1! > form?.boonLister2!
      || form?.boonLister2! > form?.boonLister3!
      || form?.posteResidenceTime1! < form?.posteResidenceTime2!
      || form?.posteResidenceTime2! < form?.posteResidenceTime3!)
      {
        setShowErrorMessage((oldValues: any) => {
          return { ...oldValues, notationGrill: true };
        });
      } else {
        setShowErrorMessage((oldValues: any) => {
          return { ...oldValues, notationGrill: false };
        });
      }
  }, [form]);

  // handle On Submit function
  async function handleOnSubmit() {
    setLoading(true);
    try {
      const response = await H2sApi.updatesH2sContractParameters(
        contractId,
        form,
      );
      if (response.status === 200) {
        ShowToast('success', 'Succès', 'Données de paramètres modifiés');
      }
    } catch (e) {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement des données de paramètres",
      );
    }
    setLoading(false);
  }
  return (
    <Container>
      <Styles />
      <Toast ref={toast} />
      <Card key={1} automatedTestId='card-notation' className='card-notation'>
        <Form onSubmit={handleOnSubmit}>
          <Word
            variant='p'
            textStyle='titleSmall'
            value='Grille de notation'
            className='card-title'
            automatedTestId='card-title'
          />
          <Container className='notation-title'>
            {/* Number title */}
            {Title()}
          </Container>
          {/* Number line */}
          <Container className='blueline'></Container>
          <Word
            variant='p'
            textStyle='normalReg'
            value='Temps de séjour(h)'
            className='notation-word'
            automatedTestId='temps-sejour'
          />
          <Container className='notation-input-component'>
            {ResidenceTime(form, setForm)}
          </Container>
          <Word
            variant='p'
            textStyle='normalReg'
            value='Vitesses d’autocurage(m/s)'
            className='notation-word'
            automatedTestId='vitesse-autocurage'
          />
          <Container className='notation-input-component'>
            {SpeedSelfcleaning(form, setForm)}
          </Container>
          <Word
            variant='p'
            textStyle='normalReg'
            value='Temps de séjour dans le poste (Nb démarrages)'
            className='notation-word'
            automatedTestId='degradation-civil'
          />
          <Container className='notation-input-component'>
            {PosteResidenceTime(form, setForm)}
          </Container>
          <Word
            variant='p'
            textStyle='normalReg'
            value='Boon et Lister (mg/L)'
            className='notation-word'
            automatedTestId='mesure-qualitative'
          />
          <Container className='notation-input-component'>
            {BoonLister(form, setForm)}
          </Container>
          {showErrorMessage.notationGrill ? (
            <Word
              variant='p'
              textStyle='normalReg'
              value='Les valeurs de la grille de notation sont erronées'
              className='error'
              automatedTestId='error'
            />
          ) : null}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {loaderDataComponent(loading, `width: 34px;
              height: 34px;
              border: 5px solid #FFF;
              border-bottom-color: #243977;
              border-radius: 50%;
              justify-content: center;
              position: relative;
              top: 1vh;
              align-items: center;
              display: inline-block;
              box-sizing: border-box;
              animation: rotation 1s linear infinite;`)}
          </div>
          {loading === false && <SaveButton disabled={showErrorMessage.notationGrill} />}
        </Form>
      </Card>
    </Container>
  );
}

export const Styles = createGlobalStyle`
.sds-reset-style{
    .card-notation{
    overflow:visible;
    background-color: white;
    height: 100%;
    margin-top: 20px;
    width: 30%;
    align-items: center;
    align-self: center;
    .card-title{
    margin-bottom: 15px;
    text-align: center;
    }
    .blueline{
    border: 0.5px solid #008BD2;
    background-color:  #008BD2;
    width: 100%;
    align-self: center;
  }
  .notation-input-component, .notation-title{
      flex-direction: row;
      justify-content: space-between;
  }
  .notation-input input{
    border: 1px solid #CCE8F6;
    border-radius: 5px;
    width: 90px !important;
    height:43px;
    text-align: center;
    background-color: white;
    margin-top: 10px;
  }
  .error{
    color: red;
  }
  .notation-word{
    text-align: center;
    margin-top: 20px;
  }
  .saveButton{
     display: flex;
    align-items: center;
    margin: 30px;
    }
  }
}`;

export default ScoringGridParameter;
